import { render, staticRenderFns } from "./ResolveLinkingOption.vue?vue&type=template&id=5c35c53b&scoped=true&"
import script from "./ResolveLinkingOption.vue?vue&type=script&lang=js&"
export * from "./ResolveLinkingOption.vue?vue&type=script&lang=js&"
import style0 from "./ResolveLinkingOption.vue?vue&type=style&index=0&id=5c35c53b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c35c53b",
  null
  
)

export default component.exports